import React from 'react';
import TransportPermitsContainer from './TransportPermitsContainer';
import ModalProvider from './shared/modalProvider';

const TransportPermitsProvider = () => {
  return (
    <ModalProvider>
      <TransportPermitsContainer />
    </ModalProvider>
  );
};

export default TransportPermitsProvider;
